import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgOftenOilyGlyphSecondary from './svgs/OftenOilyGlyphSecondary.js';
import SvgOftenOilyGlyph from './svgs/OftenOilyGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var oftenOilyGlyph = (props => useIcon(SvgOftenOilyGlyph, SvgOftenOilyGlyphSecondary, props));

export { oftenOilyGlyph as default };
